import { Grid } from '@mui/material';
import { AppLayout } from 'layout';
import { UserPersonal } from 'modules/Users/components';

type Props = {};

const PersonalUserInfoContainer = (props: Props) => {
  return (
    <AppLayout>
      <Grid bgcolor={'#FFFFFF'}>
        <UserPersonal />
      </Grid>
    </AppLayout>
  );
};

export default PersonalUserInfoContainer;
